import { createActionCreator } from "deox";
export const voucherSaving = createActionCreator("voucherSaving");
export const voucherError = createActionCreator("voucherError", (resolve) => (message: string) => resolve(message));
export const voucherSaved = createActionCreator("voucherSaved");
export const voucherInit = createActionCreator("voucherInit");
